import { FieldLite } from 'module/api/field/types';
import { User } from 'module/api/user/types';
import { CitationType } from 'api/citation/types';

export enum SignalType {
  Risk = 'RISK',
  Opportunity = 'OPPORTUNITY',
  Operational = 'OPERATIONAL',
}
export interface SignalConfiguration {
  signalConfigurationId: number;
  signalName: string;
  signalDetectionInstructions: string;
  fields: FieldLite[];
  shouldCreateTask: boolean;
  knowledgeSources?: string[];
  signalType: SignalType;
  visibleOnTimeline: boolean;
  createdBy: number | string;
  updatedBy?: number | string;
  createdAt?: string | number;
  updatedAt?: string | number;
  createdByUser?: User;
  updatedByUser?: User;
  enabled?: boolean;
  isEnabled?: boolean;
  metaData?: {
    isSignalDetectionInstructionsAiGenerated?: boolean;
  };
}
export type CreateSignalPayload = Partial<
  Omit<SignalConfiguration, 'signalConfigurationId'>
>;
export type TemporarySignalConfiguration = Omit<
  SignalConfiguration,
  'signalConfigurationId'
>;
export type GetSignalConfigurationFromPayload = Pick<
  SignalConfiguration,
  'signalName' | 'signalType'
>;

export interface SignalCitation {
  [key: string]: {
    citationType: CitationType;
    citationUuid: number;
  };
}
